import styled from 'styled-components';

const StyledImage = styled.img<{ margin?: string; width?: number; heigth?: number }>`
  margin: ${({ margin }) => margin || '0 7px 0 0'};
  width: ${({ width }) => width || 24}px;
  height: ${({ height }) => height || 24}px;
`;

export default StyledImage;
